import { Box, useTheme, Grid, Button } from "@mui/material";
import ResponsiveDialog from "components/responsiveDialog";
import FixedSizeDialog from "components/fixedSizeDialog";
import { useSelector } from "react-redux";
import { useState } from "react";
import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";
import { useShiftsList } from "api/hooks/humanResource";
import ShiftCreateForm from "../forms/shiftCreateForm";
import ShiftEditForm from "../forms/shiftEditForm";
import { requester } from "api/pesabackend";

export default function ShiftTable({ setIsSuccess }) {
  const theme = useTheme();
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [editData, setEditData] = useState("");
  const [clickedItem, setClickedItem] = useState("");
  const {shiftList, setNewShiftData, isLoadingShiftList} = useShiftsList(1, business_branch_id);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickEditOpen = async (e) => {
    const response = await requester.get(
    `/human_resource/shifts/get/${e.target.value}`
    );
    if (response.status === 200) {
      setClickedItem(e.target.value);
      setEditData(response.data.data);
      setOpenEdit(true);
    }
  };

  const handleClickEditClose = () => {
    setOpenEdit(false);
  };

  const handleClickDeleteOpen = async (e) => {
    const response = await requester.get(
    `/human_resource/shifts/get/${e.target.value}`
    );
    if (response.status === 200) {
      setClickedItem(e.target.value);
      setOpenDelete(true);
    }
  };

  const handleClickDeleteClose = () => {
    setOpenDelete(false);
  };

  const handleClickDelete = async () => {
    if (isDeleting) return;
    setIsDeleting(true);
    await requester.post(`/human_resource/shifts/delete?id=${clickedItem}`);
    setIsSuccess(true);
    setNewShiftData(true);
    setIsDeleting(false);
    setOpenDelete(false);
  };


  return (
    <Box>
      <h4>Shifts</h4>
      <Box p="1rem" m="1rem" borderRadius="0.5rem">
        <Grid container spacing={4} className="alignHorizantal">
          <Grid xs>
            
          </Grid>
          <Grid xs></Grid>
          <Grid xs sx={{ textAlign: "right" }}>
            <Button variant="contained" onClick={handleClickOpen}>
              Add New Shift
            </Button>
            <FixedSizeDialog
              dialogButtonName="Create Shift "
              dialogHeading="Create a New Shift"
              open={open}
              maxWidth={"md"}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              negativeResponse="Cancel"
              content={
                <Box
                  p="1rem"
                  borderRadius="0.5rem"
                  backgroundColor={theme.palette.background.alt}
                >
                  <ShiftCreateForm setIsSuccess={setIsSuccess} setOpen={setOpen} setNewShiftData={setNewShiftData}/>
                </Box>
              }
            />
          </Grid>
        </Grid>
      </Box>

      <ReportTable
        columns={[
          { label: "No.", width: 50 },
          { label: "Shift Name", width: 170 },
          { label: "From", width: 170 },
          { label: "To", width: 170 },
          { label: "Actions", align: "center" },
        ]}
        rows={shiftList}
        loading={isLoadingShiftList}
        emptyMessage="No data found"
        renderRow={(row, index) => (
          <RRow key={row.id} index={index}>
            <RCell>{index + 1}</RCell>
            <RCell>{row.shift_name}</RCell>
            <RCell>{row.start_time}</RCell>
            <RCell>{row.end_time}</RCell>
            <RCell align="center">
              <Button
                value={row.id}
                size="small"
                onClick={(e) => handleClickEditOpen(e)}
              >
                Edit
              </Button>

              <Button
                value={row.id}
                size="small"
                onClick={(e) => handleClickDeleteOpen(e)}
              >
                Delete
              </Button>

              <FixedSizeDialog
                dialogHeading="Edit"
                open={openEdit}
                maxWidth={"md"}
                handleClose={handleClickEditClose}
                negativeResponse="Cancel"
                content={
                  <Box
                    p="1rem"
                    borderRadius="0.5rem"
                    backgroundColor={theme.palette.background.alt}
                  >
                    {
                      <ShiftEditForm
                        setOpen={setOpenEdit}
                        setNewShiftData={setNewShiftData}
                        id={clickedItem}
                        editData={editData}
                        setIsSuccess={setIsSuccess}
                      />
                    }
                  </Box>
                }
              />

              <ResponsiveDialog
                dialogHeading="Are you sure you want to delete?"
                open={openDelete}
                handleClose={handleClickDeleteClose}
                negativeResponse="Cancel"
                content={
                  <Box
                    p="1rem"
                    borderRadius="0.5rem"
                    backgroundColor={theme.palette.background.alt}
                  >
                    {
                      <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        disabled={isDeleting}
                        onClick={handleClickDelete}
                        sx={{
                          m: "1rem 0",
                          p: "1rem",
                        }}
                      >
                        Yes, Delete
                      </Button>
                    }
                  </Box>
                }
              />
            </RCell>
          </RRow>
        )}
      />
    </Box>
  );
}
